import { useCallback } from "react";
import useChangeClothes from "@/domains/createCharacter/hooks/useChangeClothes";
import useChangeFace from "@/domains/createCharacter/hooks/useChangeFace";
import useChangeGenetics from "@/domains/createCharacter/hooks/useChangeGenetics";
import useChangeHairStyle from "@/domains/createCharacter/hooks/useChangeHairStyle";
// import useChangeHeadOverlay from "@/domains/createCharacter/hooks/useChangeHeadOverlay";
import usePersonalData from "@/domains/createCharacter/hooks/usePersonalData";
import CreateCharacterRandomAll from "@/domains/createCharacter/components/CreateCharacterRandomAll";

export default function CreateCharacterRandomAllContainer() {
  const customizeData = usePersonalData();
  const customizeGenetics = useChangeGenetics();
  const customizeFace = useChangeFace();
  const customizeHairStyle = useChangeHairStyle();
  // const customizeHeadOverlay = useChangeHeadOverlay();
  const customizeClothes = useChangeClothes();

  const randomAll = useCallback(() => {
    customizeData.randomizeAll();
    customizeGenetics.randomizeAll();
    customizeFace.randomizeAll();
    customizeHairStyle.randomizeAll();
    // customizeHeadOverlay.randomizeAll();
    customizeClothes.randomizeAll();
  }, []);

  return <CreateCharacterRandomAll onClick={randomAll} />;
}
